export const getFinanceUploadRequestsRoute = () => '/finance-upload-requests';

export const GET_UPLOAD_REQUESTS_DATA = '/opsDashboard/uploadRequest/fetch';
export const GET_UPLOAD_REQUESTS_EXCEL = '/opsDashboard/uploadRequest/getStatusExcel';
